module.exports = __webpack_public_path__ + "UX44.png?0c35c9486473e1fc6c60dafd30e201e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX44.png
// module id = 95
// module chunks = 0